import { bus } from '../core/event-bus.js';
import { store } from '../core/state-store.js';
import { formatMs } from '../utils/format.js';
import { el } from '../utils/dom.js';

let filterText = '';

export function initEventLogger() {
  const logContainer = document.getElementById('event-log');
  const filterInput = document.getElementById('event-filter');
  const clearBtn = document.getElementById('event-clear-btn');
  const exportBtn = document.getElementById('event-export-btn');

  // Filter input
  filterInput.addEventListener('input', () => {
    filterText = filterInput.value.toLowerCase();
    _applyFilter(logContainer);
  });

  // Clear button
  clearBtn.addEventListener('click', () => {
    logContainer.innerHTML = '';
  });

  // Export button
  exportBtn.addEventListener('click', () => {
    const events = store.events;
    const blob = new Blob([JSON.stringify(events, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `vast-events-${Date.now()}.json`;
    a.click();
    URL.revokeObjectURL(url);
  });

  // Listen for events
  bus.on('event:logged', (entry) => {
    _appendEntry(logContainer, entry);
  });

  // Session reset clears log
  bus.on('session:started', () => {
    logContainer.innerHTML = '';
  });
  bus.on('session:reset', () => {
    logContainer.innerHTML = '';
  });
}

function _appendEntry(container, entry) {
  const category = entry.data?.category || 'lifecycle';
  const row = el('div', {
    className: 'event-entry',
    'data-testid': 'event-entry',
    'data-category': category,
    'data-event-type': entry.type,
  }, [
    el('span', { className: 'event-time', textContent: formatMs(entry.timestamp) }),
    el('span', { className: 'event-name', textContent: entry.type }),
    el('span', { className: 'event-data', textContent: _formatEventData(entry) }),
  ]);

  if (filterText && !entry.type.includes(filterText)) {
    row.style.display = 'none';
  }

  container.insertBefore(row, container.firstChild);
}

function _formatEventData(entry) {
  if (entry.type === 'aderror' && entry.data) {
    return `[${entry.data.code ?? '?'}] ${entry.data.message || ''}`;
  }
  return '';
}

function _applyFilter(container) {
  const rows = container.querySelectorAll('.event-entry');
  rows.forEach((row) => {
    const type = row.getAttribute('data-event-type') || '';
    row.style.display = (!filterText || type.includes(filterText)) ? '' : 'none';
  });
}
